import { createCoreMethod } from '../../utils/createCoreMethod';

export const getFlowStartingPoints = createCoreMethod(
  'getFlowStartingPoints',
  async (): Promise<{ name: string; nodeId: string }[]> => {
    return new Promise((resolve) =>
      resolve([...figma.currentPage.flowStartingPoints])
    );
  }
);
